import { render, staticRenderFns } from "./AdminPlanView.vue?vue&type=template&id=21d9d920"
import script from "./AdminPlanView.vue?vue&type=script&lang=js"
export * from "./AdminPlanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports